import { NavigationPath, NavigationNested } from 'utils/navigation';

export const currentNavItemFinder =
  (pathname: string) => (item: NavigationNested | NavigationPath) => {
    const startsWith = (item as NavigationPath).startsWith;

    return startsWith
      ? startsWith.some((s) => pathname.startsWith(s))
      : (item as NavigationPath).path === pathname;
  };
